import React from 'react';
import appConfig from '@nerdwallet/app-config';
import IdContext from './IdContext';
export var createSequentialIdGenerator = function createSequentialIdGenerator(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? 'nw-aria-ssr' : _ref$prefix;
  return function generateSequentialId() {
    // eslint-disable-next-line no-plusplus,no-param-reassign
    return "".concat(prefix, "-").concat(++count);
  };
}; // NerdWallet's react-accessibility Provider,
// used to integrate Currency components with accessibility libraries and requirements
// this Provider is intended to be part of your App's SSR tree
// this means that nw-app-build/nw-app-module will NOT provide an automatic integration
// therefore, do not put this in the client(browser)-side only `client/main.jsx` file
// instead put it one step below (in nw-app-boilerplate this is `client/routes/container.jsx`)

var SSRProvider = function SSRProvider(_ref2) {
  var children = _ref2.children,
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? appConfig === null || appConfig === void 0 ? void 0 : appConfig.CLIENT_ID : _ref2$prefix;
  // instead of rendering another library's Provider (reakit, react-aria, etc...)
  // we implement our own SSR-safe solution for the `useId()` hook that is in this repo
  // and then use that to auto-generate our ids for whichever library we are currently using
  // internally in individual NDS component source code
  return /*#__PURE__*/React.createElement(IdContext.Provider, {
    value: createSequentialIdGenerator({
      count: 0,
      prefix: prefix
    })
  }, children);
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  var PropTypes = require('prop-types');

  SSRProvider.propTypes = {
    children: PropTypes.node.isRequired,
    prefix: PropTypes.string
  };
}

export default SSRProvider;